//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IconSearch from '~/assets/svg/search.svg?inline'

export default {
  components: { IconSearch },

  props: {
    isSearching: { type: Boolean, default: false },
    placeholder: { type: String, default: '' },
    value: { type: String, default: '' },
  },
}
